import {
  CarouselGame,
  LiveEvent,
  MatchWithDraw,
  SportCategory,
  StartingSoonEvent,
} from '../types/sports.types';

// Feature flag: show/hide the "Futures" tab in the Sports section (desktop sidebar
// + mobile). Hidden per client request — flip to true to bring it back.
export const SHOW_SPORTS_FUTURES_TAB = false;

export const SPORTS_UI_PATTERNS = {
  FLAT: 'single-event-flat',
  GROUPED: 'single-event-grouped',
  TABBED: 'multi-event',
};

export const MONEYLINE_TEAM1_COLOR = 'primary.main';
export const MONEYLINE_TEAM2_COLOR = 'secondary.main';
export const MONEYLINE_TEAM1_SHADOW = 'primary.dark';
export const MONEYLINE_TEAM2_SHADOW = 'secondary.dark';

export const SPORT_CATEGORIES: SportCategory[] = [
  { id: 'live', label: 'Live', icon: 'live', isLive: true },
  { id: 'futures', label: 'Futures', icon: 'futures' },
];

export const POPULAR_CATEGORIES: SportCategory[] = [
  { id: 'nfl', label: 'NFL', count: 32, icon: '🏈' },
  { id: 'nba', label: 'NBA', count: 44, icon: '🏀' },
  { id: 'ufc', label: 'UFC', count: 1, icon: '🥊' },
  { id: 'football', label: 'Football', icon: '⚽', hasDropdown: true },
  { id: 'esports', label: 'Esports', icon: '🎮', hasDropdown: true },
  { id: 'cricket', label: 'Cricket', icon: '🏏', hasDropdown: true },
  { id: 'tennis', label: 'Tennis', count: 12, icon: '🎾' },
];

export const ALL_SPORTS_CATEGORIES: SportCategory[] = [
  { id: 'american-football', label: 'American Fo...', icon: '🏈', hasDropdown: true },
  { id: 'basketball', label: 'Basketball', icon: '🏀', hasDropdown: true },
  { id: 'tennis-all', label: 'Tennis', icon: '🎾', hasDropdown: true },
  { id: 'esports-all', label: 'Esports', icon: '🎮', hasDropdown: true },
  { id: 'baseball', label: 'Baseball', icon: '⚾', hasDropdown: true },
  { id: 'football-all', label: 'Football', icon: '⚽', hasDropdown: true },
  { id: 'cricket-all', label: 'Cricket', icon: '🏏', hasDropdown: true },
  { id: 'golf', label: 'Golf', icon: '⛳' },
  { id: 'ufc-all', label: 'UFC', icon: '🥊' },
  { id: 'formula1', label: 'Formula 1', icon: '🏎️' },
  { id: 'chess', label: 'Chess', icon: '♟️' },
  { id: 'boxing', label: 'Boxing', icon: '🥊' },
];

export const MOBILE_SUB_CATEGORIES = [
  { id: 'live', label: 'Live', icon: 'live', isActive: true },
  { id: 'futures', label: 'Futures', icon: 'futures' },
  { id: 'nfl', label: 'NFL', icon: '🏈', badge: 16 },
  { id: 'nba', label: 'NBA', icon: '🏀', badge: 61 },
  { id: 'ufc', label: 'UFC', icon: '🥊', badge: 1 },
  { id: 'american-football', label: 'American Football', icon: '🏈', hasDropdown: true },
  { id: 'basketball', label: 'Basketball', icon: '🏀', hasDropdown: true },
  { id: 'esports', label: 'Esports', icon: '🎮', hasDropdown: true },
  { id: 'cricket', label: 'Cricket', icon: '🏏', hasDropdown: true },
  { id: 'tennis', label: 'Tennis', icon: '🎾', badge: 12, hasDropdown: true },
  { id: 'baseball', label: 'Baseball', icon: '⚾' },
  { id: 'golf', label: 'Golf', icon: '⛳' },
  { id: 'formula1', label: 'Formula 1', icon: '🏎️' },
  { id: 'chess', label: 'Chess', icon: '♟️' },
  { id: 'boxing', label: 'Boxing', icon: '🥊' },
];

export const LIVE_EVENTS: LiveEvent[] = [
  {
    id: 'atp-1',
    league: 'ATP',
    isLive: true,
    status: 'S2',
    volume: '$148.58k Vol.',
    gameViewCount: 10,
    player1: { name: 'Ethan Quinn', flag: '🇺🇸', scores: '4 6', shortName: 'QUINN' },
    player2: { name: 'Marton Fucsovics', flag: '🇭🇺', scores: '4 5', shortName: 'FUCSOVI' },
    price1: '0.4¢',
    price2: '99.9¢',
    spread1: { label: 'QUINN +1.5', price: '0¢' },
    spread2: { label: 'FUCS... -1.5', price: '0¢' },
    totalOver: { label: 'O 22.5', price: '0¢' },
    totalUnder: { label: 'U 22.5', price: '0¢' },
  },
  {
    id: 'atp-2',
    league: 'ATP',
    isLive: true,
    status: 'S2',
    volume: '$52.18k Vol.',
    gameViewCount: 10,
    player1: { name: 'Nuno Borges', flag: '🇵🇹', scores: '7', shortName: 'BORGES' },
    player2: { name: 'Tomas Etcheverry', flag: '🇦🇷', scores: '5', shortName: 'ETCHEVE' },
    price1: '81¢',
    price2: '22¢',
    spread1: { label: 'BORGES +1.5', price: '45¢' },
    spread2: { label: 'ETCHEVE -1.5', price: '58¢' },
    totalOver: { label: 'O 22.5', price: '98¢' },
    totalUnder: { label: 'U 22.5', price: '5¢' },
  },
  {
    id: 'atp-3',
    league: 'ATP',
    isLive: true,
    status: 'S1',
    volume: '$41.17k Vol.',
    gameViewCount: 10,
    player1: { name: 'Stefanos Tsitsipas', flag: '🇬🇷', scores: '3', shortName: 'TSITSIP' },
    player2: { name: 'Aleksandar Vukic', flag: '🇦🇺', scores: '3', shortName: 'VUKIC' },
    price1: '77¢',
    price2: '25¢',
    spread1: { label: 'TSITSIP +1.5', price: '12¢' },
    spread2: { label: 'VUKIC -1.5', price: '91¢' },
    totalOver: { label: 'O 21.5', price: '99¢' },
    totalUnder: { label: 'U 21.5', price: '4¢' },
  },
  {
    id: 'wta-1',
    league: 'WTA',
    isLive: true,
    status: 'S3',
    volume: '$139.99k Vol.',
    gameViewCount: 10,
    player1: { name: 'Mirra Andreeva', flag: '🇷🇺', scores: '5 3' },
    player2: { name: 'Linda Noskova', flag: '🇨🇿', scores: '7 2' },
    price1: '72¢',
    price2: '33¢',
  },
  {
    id: 'cs-1',
    league: 'COUNTER STRIKE',
    isLive: true,
    status: 'Game 1 • Best of 3',
    volume: '$23.26k Vol.',
    gameViewCount: 4,
    team1: { name: 'LILMIX Lilmix', score: 0 },
    team2: { name: 'BW Brave Wolves', score: 0 },
    price1: '17¢',
    price2: '86¢',
  },
  {
    id: 'cs-2',
    league: 'COUNTER STRIKE',
    isLive: true,
    status: 'Game 2 • Best of 3',
    volume: '$21.13k Vol.',
    gameViewCount: 4,
    team1: { name: 'MEG1 megoshort', score: 1 },
    team2: { name: 'XI XI Esport', score: 0 },
    price1: '97¢',
    price2: '13¢',
  },
];

export const FUTURES_MARKETS: Record<string, any[]> = {
  nfl: [
    {
      id: 'super-bowl-winner',
      title: 'Super Bowl Winner',
      teams: [
        { abbr: 'SEA', name: 'Seattle', percentage: 23, color: '#002244' },
        { abbr: 'LAR', name: 'Los Angeles R', percentage: 20, color: '#003594' },
        { abbr: 'BUF', name: 'Buffalo', percentage: 16, color: '#00338d' },
        { abbr: 'NE', name: 'New England', percentage: 13, color: '#002244' },
        { abbr: 'DEN', name: 'Denver', percentage: 10, color: '#fb4f14' },
      ],
    },
    {
      id: 'nfc-champion',
      title: 'NFC Champion',
      teams: [
        { abbr: 'SEA', name: 'Seattle', percentage: 44, color: '#002244' },
        { abbr: 'LAR', name: 'Los Angeles R', percentage: 35, color: '#003594' },
        { abbr: 'CHI', name: 'Chicago', percentage: 12, color: '#C83803' },
      ],
    },
  ],
  nba: [
    {
      id: 'nba-champion',
      title: 'NBA Champion',
      teams: [
        { abbr: 'BOS', name: 'Boston', percentage: 28, color: '#007A33' },
        { abbr: 'LAL', name: 'Los Angeles', percentage: 22, color: '#552583' },
        { abbr: 'GSW', name: 'Golden State', percentage: 18, color: '#1d428a' },
        { abbr: 'MIA', name: 'Miami', percentage: 15, color: '#98002E' },
        { abbr: 'MIL', name: 'Milwaukee', percentage: 12, color: '#00471B' },
      ],
    },
  ],
  epl: [
    {
      id: 'epl-winner',
      title: 'EPL Winner',
      teams: [
        { abbr: 'MCI', name: 'Manchester City', percentage: 35, color: '#6CABDD' },
        { abbr: 'ARS', name: 'Arsenal', percentage: 28, color: '#EF0107' },
        { abbr: 'LIV', name: 'Liverpool', percentage: 22, color: '#C8102E' },
        { abbr: 'CHE', name: 'Chelsea', percentage: 10, color: '#034694' },
        { abbr: 'TOT', name: 'Tottenham', percentage: 5, color: '#132257' },
      ],
    },
  ],
};

export const FUTURES_PLAYER_MARKETS: Record<string, any[]> = {
  nfl: [
    {
      id: 'offensive-rookie-of-the-year',
      title: 'Offensive Rookie of the Year',
      players: [
        { name: 'Tetairoa McMillan', percentage: 94 },
        { name: 'Jaxson Dart', percentage: 4 },
        { name: 'Tyler Shough', percentage: 2 },
        { name: 'Emeka Egbuka', percentage: 1 },
        { name: 'Cameron Ward', percentage: 1 },
      ],
    },
    {
      id: 'defensive-rookie-of-the-year',
      title: 'Defensive Rookie of the Year',
      players: [
        { name: 'Carson', percentage: 45 },
        { name: 'James', percentage: 28 },
        { name: 'Nick E', percentage: 15 },
        { name: 'Abdul', percentage: 8 },
        { name: 'Jalon', percentage: 4 },
      ],
    },
  ],
  nba: [],
  epl: [],
};

export const STARTING_SOON_NBA_GAMES: StartingSoonEvent[] = [
  {
    id: 'nba-1',
    time: '5:30 AM',
    volume: '$481.17k Vol.',
    gameViewCount: 41,
    team1: { abbr: 'CLE', name: 'Cavaliers', record: '20-17', color: '#860038', price: '67¢' },
    team2: { abbr: 'IND', name: 'Pacers', record: '6-30', color: '#FDBB30', price: '34¢' },
  },
  {
    id: 'nba-2',
    time: '5:30 AM',
    volume: '$287.19k Vol.',
    gameViewCount: 41,
    team1: { abbr: 'ORL', name: 'Magic', record: '20-16', color: '#0077C0', price: '72¢' },
    team2: { abbr: 'WAS', name: 'Wizards', record: '9-25', color: '#002B5C', price: '29¢' },
  },
  {
    id: 'nba-3',
    time: '6:30 AM',
    volume: '$639.90k Vol.',
    gameViewCount: 44,
    team1: { abbr: 'BOS', name: 'Celtics', record: '25-12', color: '#007A33', price: '58¢' },
    team2: { abbr: 'MIA', name: 'Heat', record: '18-19', color: '#98002E', price: '43¢' },
  },
];

export const CAROUSEL_GAMES: CarouselGame[] = [
  {
    id: '1',
    time: '9:30 PM',
    volume: '$172.37k Vol.',
    team1: { flag: '🇭', name: 'HOWRD', price: '33¢' },
    team2: { flag: '🇩', name: 'DREXEL', price: '69¢' },
  },
  {
    id: '2',
    time: '9:30 PM',
    volume: '$3.58k Vol.',
    team1: { flag: '🅰️', name: 'AKB', price: '96¢' },
    team2: { flag: '🅰️', name: 'SAL', price: '34¢' },
  },
  {
    id: '3',
    time: '9:30 PM',
    volume: '$3.33k Vol.',
    team1: { flag: '🦁', name: 'LOK', price: '58¢' },
    team2: { flag: '🦁', name: 'DIN', price: '43¢' },
  },
  {
    id: '4',
    time: '9:30 PM',
    volume: '$592.49 Vol.',
    team1: { flag: '🅽', name: 'NEF', price: '53¢' },
    team2: { flag: '🅽', name: 'TOR', price: '52¢' },
  },
  {
    id: '5',
    time: '9:30 PM',
    volume: '$3.92 Vol.',
    team1: { flag: '🇳🇴', name: 'NOR', price: '87¢' },
    team2: { flag: '🇿🇦', name: 'SA', price: '50¢' },
  },
];

export const MATCHES_WITH_DRAW: MatchWithDraw[] = [
  {
    id: 'bl2-1',
    league: 'BL 2',
    time: '11:00 PM',
    volume: '$264.55k Vol.',
    gameViewCount: 8,
    team1: {
      abbr: 'DUS',
      name: 'DUS TSV Fortuna 95 Düsseldorf',
      record: '5-2-10',
      color: 'error.main',
      price: '38¢',
    },
    team2: {
      abbr: 'BIE',
      name: 'BIE DSC Arminia Bielefeld',
      record: '5-4-8',
      color: 'primary.main',
      price: '35¢',
    },
    drawPrice: '28¢',
  },
  {
    id: 'bl2-2',
    league: 'BL 2',
    time: '11:00 PM',
    volume: '$145.41k Vol.',
    gameViewCount: 8,
    team1: {
      abbr: 'BRA',
      name: 'BRA Eintracht Braunschweig',
      record: '6-2-9',
      color: 'warning.main',
      price: '36¢',
    },
    team2: {
      abbr: 'FCM',
      name: 'FCM 1. FC Magdeburg',
      record: '5-2-10',
      color: 'primary.main',
      price: '40¢',
    },
    drawPrice: '27¢',
  },
  {
    id: 'lol-1',
    league: 'LEAGUE OF LEGENDS',
    time: '1:30 PM',
    volume: '$63.33k Vol.',
    gameViewCount: 9,
    team1: {
      abbr: 'GZ',
      name: 'GZ Ground Zero Gaming',
      record: '1-0',
      color: 'success.main',
      price: '60¢',
    },
    team2: {
      abbr: 'TSW',
      name: 'TSW Team Secret Whales',
      record: '0-1',
      color: 'text.primary',
      price: '51¢',
    },
    drawPrice: '0¢',
  },
];
